/**
 * @todo load recent setpoint asset
 * @todo load RAG counters
 */
import { Component, OnInit, Input, OnDestroy, signal } from '@angular/core';
import { DashboardService } from 'app/shared/dashboard.service';
import { Asset } from 'app/classes/asset';

@Component({
  selector: 'app-dashboard-tile-data-setpoints',
  templateUrl: './dashboard-tile-data-setpoints.component.html',
  styleUrls: ['./dashboard-tile-data-setpoints.component.css'],
  standalone: false
})
export class DashboardTileDataSetpointsComponent implements OnInit, OnDestroy {
  _recent = signal<any>(null);
  hasValue = signal<boolean>(false);
  totals = signal<RAG>(null);
  timer: any;

  @Input()
  public get recent(): any {
    return this._recent;
  }
  public set recent(v: any) {
    this.hasValue.set(!!v);
    this._recent.set(v);
    setTimeout(() => {
      this.hasValue.set(false);
    }, 1500);
  }

  asset: Asset;
  constructor(private dashboardService: DashboardService) { }

  ngOnDestroy(): void {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  ngOnInit() {
    // @deprecated this.asset = new Asset({ id: 128, title: 'AHU Left', assetType_id: 2, value: 28 });
    this.asset = new Asset();
    this.getSetpointTotals();

    this.timer = setInterval(() => {
      this.getSetpointTotals();
    }, 60000);
  }

  getSetpointTotals() {
    this.dashboardService.getSetpointTotals().subscribe(totals => {
      if (JSON.stringify(this.totals()) !== JSON.stringify(<RAG>totals)) {
        this.totals.set(<RAG>totals);
      }
    });
  }
}

export interface RAG {
  red: number;
  amber: number;
  green: number;
}
